import { ICON_TYPES } from '@shared/constants/icon-types';
import cx from 'classnames';

const getIconStyle = (googleStyle, className) => cx(googleStyle, className);

export const EVENT_WARNING_TYPES = {
  APPRAISAL_DETAILS_DUE_SOON: 1,
  APPRAISAL_DETAILS_PAST_DUE: 2,
  APPRAISAL_MUST_BE_RESCHEDULED: 3,
  REAPPRAISAL_RATIONALE_PENDING_SUBMISSION: 4,
  REAPPRAISAL_RATIONALE_RETURNED_BY_FDA: 5,
  REAPPRAISAL_RATIONALE_PENDING_FDA_APPROVAL: 6,
  REAPPRAISAL_RATIONALE_APPROVED: 7,
  ATM_BID_SUBMISSION: 8,
  EVENT_PENDING_REVIEW: 9,
  EVENT_PENDING_SUBMISSION: 10,
  EVENT_NEED_OBSERVER: 11,
  DC_EVENT: 12
};

export const WARNING_SCOPE = {
  ATL_DATE: 0,
  REAPPRAISAL_RATIONALE: 1,
  APPRAISAL_DETAIL: 2
};

export const WARNING_SETTINGS_MAP = new Map([
  [
    EVENT_WARNING_TYPES.APPRAISAL_DETAILS_DUE_SOON,
    {
      title: 'Appraisal details due soon.',
      iconType: ICON_TYPES.Warning,
      scope: WARNING_SCOPE.ATL_DATE,
      iconStyle: getIconStyle('material-icons', 'yellow-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.APPRAISAL_DETAILS_PAST_DUE,
    {
      title: 'Appraisal details past due. Risk of appraisal being rescheduled.',
      iconType: ICON_TYPES.Warning,
      scope: WARNING_SCOPE.ATL_DATE,
      iconStyle: getIconStyle('material-icons', 'red-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.APPRAISAL_MUST_BE_RESCHEDULED,
    {
      title: 'Appraisal must be rescheduled.',
      iconType: ICON_TYPES.Warning,
      scope: WARNING_SCOPE.ATL_DATE,
      iconStyle: getIconStyle('material-icons', 'black-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_PENDING_SUBMISSION,
    {
      title: 'Need to submit reappraisal rationale via Check Point.',
      iconType: ICON_TYPES.PendingActions,
      scope: WARNING_SCOPE.REAPPRAISAL_RATIONALE,
      iconStyle: getIconStyle('material-icons', 'red-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_RETURNED_BY_FDA,
    {
      title: 'Need to submit reappraisal rationale via Check Point.',
      iconType: ICON_TYPES.PendingActions,
      scope: WARNING_SCOPE.REAPPRAISAL_RATIONALE,
      iconStyle: getIconStyle('material-icons', 'red-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_PENDING_FDA_APPROVAL,
    {
      title: 'Reappraisal rationale pending FDA approval.',
      iconType: ICON_TYPES.PendingActions,
      scope: WARNING_SCOPE.REAPPRAISAL_RATIONALE,
      iconStyle: getIconStyle('material-icons', 'red-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.REAPPRAISAL_RATIONALE_APPROVED,
    {
      title: 'Reappraisal rationale has been approved.',
      iconType: ICON_TYPES.Verified,
      scope: WARNING_SCOPE.REAPPRAISAL_RATIONALE,
      iconStyle: getIconStyle('material-icons', 'black-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.ATM_BID_SUBMISSION,
    {
      title: 'Bid pending review.',
      googleStyle: 'material-symbols-outlined',
      iconType: ICON_TYPES.OtherAdmission,
      iconStyle: getIconStyle('material-symbols-outlined')
    }
  ],
  [
    EVENT_WARNING_TYPES.EVENT_PENDING_REVIEW,
    {
      title: 'Appraisal details pending ISACA approval',
      googleStyle: 'material-symbols-outlined',
      iconType: ICON_TYPES.Chronic,
      scope: WARNING_SCOPE.APPRAISAL_DETAIL,
      iconStyle: getIconStyle('material-symbols-outlined')
    }
  ],
  [
    EVENT_WARNING_TYPES.EVENT_PENDING_SUBMISSION,
    {
      scope: WARNING_SCOPE.APPRAISAL_DETAIL,
      hideIconForCalendarPage: true
    }
  ],
  [
    EVENT_WARNING_TYPES.EVENT_NEED_OBSERVER,
    {
      title: 'ATL Observer/Coach needed.',
      googleStyle: 'material-symbols-outlined',
      iconType: ICON_TYPES.PersonAlert,
      iconStyle: getIconStyle('material-symbols-outlined', 'red-warning')
    }
  ],
  [
    EVENT_WARNING_TYPES.DC_EVENT,
    {
      title: 'Direct Channel',
      googleStyle: 'material-symbols-outlined',
      iconType: ICON_TYPES.Outbound,
      iconStyle: getIconStyle('material-symbols-outlined', 'black-warning')
    }
  ]
]);
